const baseURL = "/v1/Administracao/Permissao";

const service = {
  methods: {
    $buscarPermissoes(params) {
      return this.$api().get(`${baseURL}`, params);
    },
  }
};

export default service;
